import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '../../../_services/essentials/helpers';

import {
    customersActions as myActions,
    alertActions,
    breadcrumbsActions
} from '../../../_services/essentials/store';
import { TextField, Button, Stack, FormControl } from '@mui/material';
import Typography from "@mui/material/Typography";
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
const Card = styled(MuiCard)(({ theme }) => ({
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    margin: 'auto',
    borderRadius: '8px', // Rounded corners
    background: 'var(--Neutral-White, #FFF)', // Background color
    boxShadow: '0px 12px 26px 0px rgba(16, 30, 115, 0.06)', // Floating shadow
    [theme.breakpoints.up('sm')]: {
        width: '35%',
    },
}));
export { AddEdit };

function AddEdit(props) {

    //    const entity_name = "customer";
    const entity_label = "Customer";
    const entities_name = "customers";
    //    const entities_label = "Customers";

    const { id } = useParams();
    const dispatch = useDispatch();
    const entity = useSelector(x => x.customers?.item);

    // form validation rules
    const validationSchema = Yup.object().shape({
        organizationName: Yup.string().trim()
            .required('Required*').max(120, 'Cannot exceed 120 characters'),
        websiteURL: Yup.string().trim().url("Please enter a valid URL (http://www.kypl.com)")
            .required('Required*').max(250, 'Cannot exceed 250 characters'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };
    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState } = useForm(formOptions);
    const { errors } = formState;

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(entity_label));
        if (id) {
            // fetch user details into redux state and
            // populate form fields with reset()
            dispatch(myActions.getById(id)).unwrap()
                .then(entity => {
                    reset(entity);
                });

        } else {
            const newEntity = {
                organizationName: "",
                websiteURL: ""
            };
            dispatch(myActions.getNewEntity(newEntity)).unwrap()
                .then(entity => {
                    reset(entity);
                });
        }
    }, [id, dispatch, reset]);

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param
            let message;
            if (id) {
                await dispatch(myActions.update({ id, data })).unwrap();
                //TODO: Make use of return value. and display message based on return value
                message = `${entity_label} details updated successfully`;
                dispatch(alertActions.success({ message, showAfterRedirect: false }));
            } else {
                const response = await dispatch(myActions.create({ data })).unwrap();
                //TODO: Make use of return value. and display message based on return value
                message = response;
                history.navigate(`${entities_name}`);
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
            }


        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <React.Fragment>
            <Card sx={{
                ml: 2
            }}>
                <Stack
                    sx={{
                        //minWidth: '900px',
                        justifyContent: 'space-between', flexGrow: '1', gap: 1
                    }}
                // size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                >
                    <Stack direction="column" size={{ xs: 6, sm: 6, md: 3, lg: 3 }} sx={{ flexGrow: '1', gap: 1 }}>
                        {/* <Stack direction="column" size={{ xs: 12, sm: 12, md: 12, lg: 12 }}> */}
                        {/* <Typography component="h2" variant="h6" sx={{mb: 2}}>
                            <ArrowLeftIcon onClick={() => history.navigate(-1)} sx={{fontSize: '48px', mb:0.5, cursor: 'pointer'}} />{id ? `${entity_label}` : `Add New ${entity_label}`}
                        </Typography> */}
                        {/* <ArrowLeftIcon onClick={() => history.navigate(-1)} sx={{fontSize: '48px', mb:0.5, cursor: 'pointer'}} />{id ? `${entity_label}` : `Add New ${entity_label}`} */}

                        {/* </Stack> */}
                        {!(entity?.loading || entity?.error) &&
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Stack direction="column" size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <FormControl>
                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Organization Name<span style={{ color: 'red' }}>*</span></Typography>
                                        <TextField
                                            id="organizationName"
                                            name="organizationName"
                                            type="text"
                                            variant='outlined'
                                            color='primary'
                                            // label="Organization Name*"
                                            placeholder={""}
                                            autoComplete="off"
                                            sx={{ mb: 4 }}
                                            inputlabelprops={{ shrink: true }}
                                            {...register('organizationName', { required: true })}
                                            error={Boolean(errors.organizationName)}
                                            helperText={errors.organizationName ? errors.organizationName.message : ""}
                                            inputProps={{
                                                maxLength: 120,
                                            }}
                                        />
                                    </FormControl>
                                </Stack>
                                <Stack direction="column" size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                    <FormControl>
                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Website URL<span style={{ color: 'red' }}>*</span></Typography>

                                        <TextField
                                            id="websiteURL"
                                            name="websiteURL"
                                            type="text"
                                            variant='outlined'
                                            color='primary'
                                            // label="Website URL*"
                                            placeholder={""}
                                            autoComplete="off"
                                            multiline
                                            sx={{ mb: 4 }}
                                            inputlabelprops={{ shrink: true }}
                                            {...register('websiteURL', { required: true })}
                                            error={Boolean(errors.websiteURL)}
                                            helperText={errors.websiteURL ? errors.websiteURL.message : " "}
                                            inputProps={{
                                                maxLength: 250,
                                            }}
                                        />
                                    </FormControl>
                                </Stack>
                                {/* <Stack direction="column" size={{ xs: 12, sm: 12, md: 12, lg: 12 }}> */}
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1, ml: '10%' }} >
                                    <FormControl>

                                        <Stack direction="row" spacing={2} sx={{ mt: 0.5 }} >
                                            {/* <Stack direction="row" spacing={1} sx={{ mb: 0.5, mt: 0.5, pl: '2.5%', justifyContent: 'left' }} > */}
                                            <Button type={"submit"} variant="contained" color="primary" size="small"
                                                sx={{ fontSize: 16, fontWeight: 600 }}
                                            >
                                                Save
                                            </Button>
                                            <Button onClick={() => reset()} variant="outlined" size="small"
                                                sx={{ backgroundColor: 'buttonVar.reset', color: 'buttonVar.resetText', fontSize: 16, fontWeight: 600 }}
                                            >
                                                Reset
                                            </Button>
                                            <Button onClick={() => history.navigate(-1)} variant="outlined"
                                                size="small" sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}  >
                                                Cancel
                                            </Button>

                                        </Stack>

                                    </FormControl>
                                </Stack>
                            </form>
                        }
                    </Stack>
                </Stack>
            </Card>
        </React.Fragment>
    );
}
